<se-po-open-registration-search
  [searchTerm]="searchTerm"
  [filters]="filters"
  [sports]="sports"
  [organizations]="organizations"
  [signupTypeList]="signupTypeList"
  [people]="people"
  [showPersonFilter]="true"
  (searchTermChange)="handleSearchTermChange($event)"
  (filtersChange)="handleFiltersChange($event)">
</se-po-open-registration-search>

<se-fe-page seFeDataWidth="full" [seFeDataLoaded]="loaded">
  <div seFePageContent>
    <section class="completed-registration-list">
      @if (!loaded) {
        <div class="completed-registration-list__loading">
          <se-fe-spinner
            [seFeDataSize]="900"
            [seFeDataCenter]="true">
          </se-fe-spinner>
        </div>
      }

      @if (loaded && error) {
        <se-fe-empty-state
          class="completed-registration-list__empty-state"
          [seFeDataTitle]="translateKey + 'load_error' | translate">
          <se-fe-icon
            class="completed-registration-list__empty-state-icon"
            seFeEmptyStateIcon
            seFeDataName="spot_service_breakdown"
            [seFeDataMargin]="false">
          </se-fe-icon>
        </se-fe-empty-state>
      }

      @if (loaded && !error && !surveyResults.length) {
        <se-fe-empty-state
          class="completed-registration-list__empty-state"
          [seFeDataTitle]="translateKey + 'empty' | translate">
          <se-fe-icon
            class="completed-registration-list__empty-state-icon"
            seFeEmptyStateIcon
            seFeDataName="spot_flat_ball"
            [seFeDataMargin]="false">
          </se-fe-icon>
        </se-fe-empty-state>
      }

      @if (loaded && !error && surveyResults.length && noResults) {
        <se-fe-empty-state
          class="completed-registration-list__empty-state"
          [seFeDataTitle]="translateKey + 'no_matches' | translate">
          <se-fe-icon
            class="completed-registration-list__empty-state-icon"
            seFeEmptyStateIcon
            seFeDataName="spot_flat_ball"
            [seFeDataMargin]="false">
          </se-fe-icon>
          <se-fe-button
            seFeEmptyStateAction
            seFeDataEmphasis="high"
            (click)="clearFilters()">
            {{ translateKey + 'clear_filters' | translate }}
          </se-fe-button>
        </se-fe-empty-state>
      }

      @if (loaded && !error && filteredCards.length) {
        <div class="completed-registration-list__cards">
          @for (card of filteredCards; track card.id) {
            <se-open-registration-card
              [registrationName]="card.registrationName"
              [orgName]="card.orgName"
              [orgLogoUrl]="card.orgLogoUrl"
              [orgColor]="card.orgColor"
              [sport]="card.sport"
              [type]="card.type"
              [avatarUrl]="card.avatarUrl"
              [backgroundImgUrl]="card.backgroundImgUrl"
              [infoHeaderText]="card.completedDate
                ? (translateKey + 'completed_on' | translate: { date: card.completedDate })
                : (translateKey + 'completed' | translate)"
              [orderRouterLink]="card.orderRouterLink"
              [orderRouterQueryParams]="card.orderRouterQueryParams"
              [showShareAction]="card.showShareAction">
            </se-open-registration-card>
          }
        </div>
        <div class="completed-registration-list__scroll-spacer" aria-hidden="true"></div>
      }
    </section>
  </div>
</se-fe-page>
